import DealConstants from 'arbitrip-common/client/constants/DealConstants';

export default DealConstants;
